import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "#193446",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m18.4972 2.26804 3.2348 3.23475c.1716.17158.268.40429.268.64695 0 .24266-.0964.47537-.268.64695l-1.0507 1.05065-4.5286-4.52866 1.0506-1.05064c.1717-.17159.4043-.26798.647-.26798.2427 0 .4754.0964.6469.26798Zm-3.4766 2.18281 4.5286 4.52866L8.79298 19.7357 2 22l2.26433-6.793L15.0206 4.45085Z"/>' }
  })
);